import React, { FC, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  LowIndicator,
  AgreementIndicatorCont,
  HighIndicator,
  ModerateIndicator,
  DisagreementIndicator,
} from './AgreementIndicator.styles';
import Tooltip from '../../HOC/Tooltip/Tooltip';
import InfoIcon from '@/assets/icons/infogrey.svg?react';

interface IAgreementIndicator {
  mode: 'disagreement' | 'low' | 'high' | 'moderate';
}

const AgreementIndicator: FC<IAgreementIndicator> = ({ mode }) => {
  const [description, setDescription] = useState('');
  const { t } = useTranslation();
  const renderIndicator = useMemo(() => {
    switch (mode) {
      case 'high': {
        setDescription(t('report.results.highAgreementDescription'));
        return <HighIndicator>{t('report.results.highAgreement')}</HighIndicator>;
      }
      case 'moderate': {
        setDescription(t('report.results.moderateAgreementDescription'));
        return <ModerateIndicator>{t('report.results.moderateAgreement')}</ModerateIndicator>;
      }
      case 'low': {
        setDescription(t('report.results.lowAgreementDescription'));
        return <LowIndicator>{t('report.results.lowAgreement')}</LowIndicator>;
      }
      case 'disagreement': {
        setDescription(t('report.results.disagreementDescription'));
        return <DisagreementIndicator>{t('report.results.disagreement')}</DisagreementIndicator>;
      }
      default: {
        setDescription(t('report.results.disagreementDescription'));
        return <DisagreementIndicator>{t('report.results.disagreement')}</DisagreementIndicator>;
      }
    }
  }, [mode]);

  return (
    <AgreementIndicatorCont id="AgreementIndicatorCont">
      {renderIndicator}
      <Tooltip
        position="top"
        positionY="22px"
        positionX="-576px"
        arrowPositionX="584px"
        width="600px"
        tooltipDesc={description}
      >
        <InfoIcon data-testid="infoOnIndicator" />
      </Tooltip>
    </AgreementIndicatorCont>
  );
};
export default AgreementIndicator;
